<div class="tile-container-skeleton" *ngIf="loadingData">
  <div fxLayoutAlign="center">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>
</div>
<div class="tile-container" *ngIf="!loadingData && topThree.length > 0">
  <div fxLayout="column" style="align-self: center">
    <div fxLayout="row" class="tile-header">
      Increased Session Lift in Micro-moment
    </div>
    <div class="primary-color average-lift" fxLayoutAlign="center">{{ averageLift }}%</div>
    <div class="descr" fxLayout="row" fxFlexAlign="center">
      Average lift to web traffic in the five minute micro-moment compared to five minute window before the
      micro-moment.
    </div>
    <mat-divider></mat-divider>
    <div fxLayout="row" class="top-3" fxLayoutGap="1%" fxLayoutAlign="stretch">
      <div
        *ngFor="let record of topThree; trackBy: trackByFn"
        fxLayout="column"
        fxLayoutAlign="center"
        class="lift-block"
        fxFlex="32.5"
      >
        <div class="isci" fxLayoutAlign="center" matTooltipPosition='above' [matTooltip]="record.spot.isci" >
          {{ formatIsci(record.spot.isci) }}
        </div>
        <div [class]="'lift ' + record.class">{{ record.spot.avgPctLift }}%</div>
      </div>
    </div>
    <div class="btn-container" fxFlex="100%" fxLayout="row" *ngIf="creatives && creatives.length > 3">
      <button (click)="showFull()" mat-stroked-button color="primary">VIEW ALL CREATIVES</button>
    </div>
  </div>
</div>
<div class="no-data tile-container" *ngIf="!loadingData && topThree.length === 0">
  No Data for Range
</div>
